<template>
    <div class="container-fluid">
        <form class="d-flex mb-3">
            <label
                for="agency"
                class="align-self-center me-3"
                >Select Agency</label
            >
            <div class="col-3">
                <b-agency
                    v-model="agency"
                    :can-clear="false"
                    :select-first="true"></b-agency>
            </div>
        </form>

        <agency-notice :ori="agency"></agency-notice>

        <agency-submission :ori="agency"></agency-submission>

        <agency-overview :ori="agency"></agency-overview>

        <system-alerts></system-alerts>
    </div>
</template>

<script lang="ts" setup>
import SystemAlerts from "./Misc/SystemAlerts.vue";
import {BAgency} from "./Fields";
import AgencyOverview from "./AgencyDashboard/AgencyOverview.vue";
import AgencyNotice from "./AgencyDashboard/AgencyNotice.vue";
import AgencySubmission from "./AgencyDashboard/AgencySubmission.vue";
import {ref} from "vue";

const agency = ref();

</script>

<style>
.block {
    margin-left: 50px;
}
</style>
